/* unplugin-vue-components disabled */import script from "./SubmitView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./SubmitView.vue?vue&type=script&lang=tsx&setup=true"

import "./SubmitView.vue?vue&type=style&index=0&id=c57e94ac&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57e94ac"]])

export default __exports__